import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => ({
  gallery: {
    height: '100%',
    marginTop: '30px',
  },
}));
